export default __webpack_public_path__ + "49c25360632a60abc0eed963ee74d599.png";